export const tributacao = [
  { tipo: "T", desc: "Tributado em São Paulo." },
  { tipo: "F", desc: "Tributado Fora de São Paulo." },
  { tipo: "A", desc: "Tributado em São Paulo, porém Isento." },
  { tipo: "B", desc: "Tributado Fora de São Paulo, porém Isento." },
  { tipo: "D", desc: "Tributado em São Paulo com isenção parcia." },
  {
    tipo: "M",
    desc: "Tributado em São Paulo, porém com indicação de imunidade subjetiva."
  },
  {
    tipo: "N",
    desc:
      "Tributado Fora de São Paulo, porém com indicação de imunidade subjetiva."
  },
  {
    tipo: "R",
    desc: "Tributado em São Paulo, porém com indicação de imunidade objetiva."
  },
  {
    tipo: "S",
    desc:
      "Tributado fora de São Paulo, porém com indicação de imunidade objetiva."
  },
  {
    tipo: "X",
    desc: "Tributado em São Paulo, porém Exigibilidade Suspensa."
  },
  {
    tipo: "V",
    desc: "Tributado Fora de São Paulo, porém Exigibilidade Suspensa."
  },
  { tipo: "P", desc: "Exportação de Serviços." },
  { tipo: "U0", desc: "Upload, sem informação de tributação." }
];

export const simples = [
  { tipo: "0", desc: "Não optante pelo Simples Federal nem Municipal" },
  { tipo: "1", desc: "Optante pelo Simples Federal (Alíquota de 1,0%)" },
  { tipo: "2", desc: "Optante pelo Simples Federal (Alíquota de 0,5%)" },
  { tipo: "3", desc: "Optante pelo Simples Municipal." },
  { tipo: "4", desc: "Optante pelo Simples Nacional." },
  { tipo: "5", desc: "Não Contratado"}
];

export const findTributacao = async function(obj) {
  let trib = null;
  tributacao.forEach(item => {
    if (item.tipo == obj) {
      trib = item;
    }
  });
  return trib;
};
export const findSimples = async function(obj) {
  let simp = null;
  simples.forEach(item => {
    if (item.tipo == obj) {
      simp = item;
    }
  });
  return simp;
};

const DEFAULT_VALUE_RETURN = '0,00';

const LIMIT_VALUE_TO_FORMAT = 10;

const validaValorMaximoAliquota = (aliquota) =>  Number(aliquota) < LIMIT_VALUE_TO_FORMAT;

export const formataAliquota = (aliqServico) => {
  var aliquota = 0;

  if (String(aliqServico).includes('0.')) {
    aliquota = String(aliqServico).replace('0.0', '')
    if(validaValorMaximoAliquota(aliquota)) return String(Number(aliquota));
    return String(Number(`${aliquota[0]}.${aliquota[1]}${aliquota[2] ? aliquota[2] : 0}`))
  } else {
    if(!String(aliqServico).includes('0.')) {
      aliquota = String(aliqServico).replace('0.', '')
      if(validaValorMaximoAliquota(aliquota)) return String(Number(aliquota));
      return String(Number(`${aliquota[0]}.${aliquota[1]}${aliquota[2] ? aliquota[2] : 0}`))
    }
 }

 return DEFAULT_VALUE_RETURN;
}



// WEBPACK FOOTER //
// ./src/domain/notas/nfse/util.js